<template>
    <div class="bg">
        <el-header style="height: 4%; display: flex;justify-content: space-between;">
            <div style="display: flex;gap:10px;">
                <img src="@/assets/favicon.png" alt="">
                <div class="header-text-left">凌丰供应商系统</div>
                <div class="pe-header-text">加工单（总览）</div>
            </div>
            <div style="width: 320px;">
                <div class="header-right">欢迎您，{{ userNme }} ({{ roleName }}) </div>
                <div class="header-right" style="color: #fff;">{{ homeDate }}</div>
            </div>
        </el-header>
        <div class="proc_nav">
            <div class="nav_left">
                <el-descriptions title="" :column="3" border>
                    <el-descriptions-item label="加工单编号" :contentStyle="{ width: '200px', }" :labelStyle="labelStyle">
                        <el-input style="width: 100%;font-size: 14px;" clearable @change="search"
                            v-model="search_obj.formCode" placeholder="请输入单据编号" size="small">
                        </el-input>
                    </el-descriptions-item>
                    <el-descriptions-item label="项目名称" contentStyle='width:250px' :labelStyle="labelStyle">
                        <el-input style="width: 100%;font-size: 14px;" clearable @change="search"
                            v-model="search_obj.projectName" placeholder="请输入项目名称" size="small">
                        </el-input>
                    </el-descriptions-item>
                    <el-descriptions-item label="合同号" contentStyle='width :200px' :labelStyle="labelStyle">
                        <el-select style="width: 100%;font-size: 14px;" size="small" clearable @change="search"
                            value-key="id" v-model="search_obj.projectId" filterable placeholder="输入并选择合同号"
                            default-first-option remote :remote-method="async_projectId" :loading="loading2">
                            <el-option v-for="item in project_options" :key="item.id" :label="item.trackNumber"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-descriptions-item>
                    <el-descriptions-item label="组件名称" contentStyle="width: 200px" :labelStyle="labelStyle">
                        <el-input style="width: 100%;font-size: 14px;" clearable @change="search"
                            v-model="search_obj.headMaterial" placeholder="请输入组件名称" size="small">
                        </el-input>
                    </el-descriptions-item>
                    <el-descriptions-item label="零件名称" contentStyle='width :200px' :labelStyle="labelStyle">
                        <div style="display: flex;">
                            <el-select style="width: 100%;font-size: 14px;" size="small" clearable @change="search"
                                v-model="search_obj.materialId" filterable placeholder="输入并选择加工件" default-first-option
                                remote :remote-method="async_procMaterial" :loading="loading2" value-key="id">
                                <el-option v-for="item in procMaterial_options" :key="item.id"
                                    :label="item.materialName + '--' + item.materialCode" :value="item.id">
                                </el-option>
                            </el-select>
                        </div>
                    </el-descriptions-item>
                    <el-descriptions-item label="其它条件" contentStyle='width :250px' :labelStyle="labelStyle">
                        <div style="width: 100%;text-align:center;line-height: 18px;">
                            <el-link type="primary" @click="other_show = true">展开</el-link>
                        </div>
                    </el-descriptions-item>
                </el-descriptions>
            </div>
            <div class="nav_right">
                <el-button size="small" type="primary" @click="search">搜索</el-button>
                <el-button size="small" type="success" @click="get_data">刷新</el-button>
                <el-checkbox style="margin-left: 10px;" v-model="search_obj.isAudit"
                    @change="search">只显示未发货/部分发货</el-checkbox>
            </div>
        </div>
        <div class="table-body">
            <el-table ref="procTable" :data="table_data" border stripe height="100%" :header-row-style="{ height: '0' }"
                :header-cell-style="{
                    background: '#78b5ec',
                    color: '#000',
                    padding: '0',
                    fontWeight: '400',
                    textAlign: 'center',
                }" :row-style="{ height: '35px' }" :cell-style="{ padding: '2px 0' }" row-key="id">
                <el-table-column label="加工单编号" prop="formCode" width="170" align="left" show-overflow-tooltip
                    sortable></el-table-column>
                <el-table-column label="建单日期" prop="createTime" width="120" align="center" sortable>
                    <template slot-scope="ss">
                        {{ formatDateYear(ss.row.createTime) }}
                    </template>
                </el-table-column>
                <el-table-column label="需用日期" prop="deadline" width="120" align="center" sortable>
                    <template slot-scope="ss">
                        {{ formatDateYear(ss.row.deadline) }}
                    </template>
                </el-table-column>
                <el-table-column label="加工商" prop="supplier.supplierName" width="180" align="left" show-overflow-tooltip
                    sortable></el-table-column>
                <el-table-column label="合同号" prop="project.trackNumber" width="220" align="left" show-overflow-tooltip
                    sortable></el-table-column>
                <el-table-column label="项目名称" prop="projectName" width="auto" align="left" show-overflow-tooltip
                    sortable></el-table-column>
                <el-table-column label="组件名称" prop="headMaterial" width="auto" align="left" show-overflow-tooltip
                    sortable></el-table-column>
                <el-table-column label="金额" prop="totalPrice" width="100" align="center" sortable></el-table-column>
                <el-table-column label="数量" prop="qty" width="90" align="center" sortable></el-table-column>
                <el-table-column label="已申请" prop="sentQty" width="90" align="center" sortable>
                    <template slot-scope="ss">
                        {{ ss.row.sentQty ? ss.row.sentQty : '' }}
                    </template>
                </el-table-column>
                <el-table-column label="已发货" prop="approvedQty" width="90" align="center" sortable>
                    <template slot-scope="ss">
                        {{ ss.row.approvedQty ? ss.row.approvedQty : '' }}
                    </template>
                </el-table-column>
                <el-table-column label="已签收" prop="arrivedQty" width="90" align="center" sortable>
                    <template slot-scope="ss">
                        {{ ss.row.arrivedQty ? ss.row.arrivedQty : '' }}
                    </template>
                </el-table-column>
                <el-table-column align="center" label="明细" width="90">
                    <template slot-scope="ss">
                        <el-link type="primary" @click="gotoItem(ss.row)">查看</el-link>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="table-footer">
            <el-pagination background layout="sizes, prev, pager, next, total" :total="total"
                @size-change="handleSizeChange" @current-change="change_data" :current-page="search_obj.currentPage"
                :page-size="search_obj.pageSize" :page-sizes="[10, 30, 50, 100, 200, 300, 400, 500]">
            </el-pagination>
        </div>
        <el-footer class="page_footer" style="">© 2024 LINKFAIRTECH 版权所有</el-footer>

        <el-dialog title="其它搜索条件" :visible.sync="other_show" width="30%">
            <el-form ref="other_search_form" :model="search_obj">
                <el-form-item label="建单日期" label-width="80px" prop="createTime">
                    <el-date-picker v-model="dateRange1" type="datetimerange" align="right"
                        style="font-size: 14px;width: 100%;" @change="search" start-placeholder="开始日期"
                        end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']"
                        value-format="yyyy-MM-dd HH:mm:ss" size="middle">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="需用日期" label-width="80px" prop="deadline">
                    <el-date-picker v-model="dateRange2" type="datetimerange" align="right"
                        style="font-size: 14px;width: 100%;" @change="search" start-placeholder="开始日期"
                        end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']"
                        value-format="yyyy-MM-dd HH:mm:ss" size="middle">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="加工商" label-width="80px" prop="deadline" v-if="roleName != '供应商'">
                    <el-select style="width: 80%;font-size: 14px;" size="middle" clearable
                        v-model="search_obj.supplierId" @change="search" filterable placeholder="输入并选择加工商"
                        default-first-option remote :remote-method="async_procSupplier" :loading="loading2"
                        value-key="id">
                        <el-option v-for="item in procSupplier_options" :key="item.id" :label="item.supplierName"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="other_show = false">取 消</el-button>
                <el-button type="success" plain size="small" @click="other_search">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { get_procSupplier, formatDateYear, get_procMaterial, get_project } from '@/utils/func';
import { getOutSourceHeadApi } from '@/Api/procApi'
export default {
    name: 'proc',
    components: {
    },
    data() {
        return {
            timer: '',
            homeDate: '',
            userNme: sessionStorage.getItem('userName'),
            labelStyle: { width: '70px', textAlign: 'center', color: '#4d4d4d', backgroundColor: '#fff' },
            search_obj: {
                formCode: '',
                materialId: '',
                projectId: '',
                supplierId: '',
                headMaterial: '',
                projectName: '',
                status: '',
                startCreateTime: '',
                endCreateTime: '',
                startDeadline: '',
                endDeadline: '',
                isAudit: true,
                pageSize: 50,
                currentPage: 1
            },
            total: 30,
            header: {
                headers: { token: sessionStorage.getItem('token') }
            },
            table_data: [],
            loading2: false,
            project_options: [],
            procMaterial_options: [],
            procSupplier_options: [],
            roleName: sessionStorage.getItem('roleName'),
            flag: false,
            other_show: false,

        }
    },
    computed: {
        dateRange1: {
            get() {
                return [this.search_obj.startCreateTime, this.search_obj.endCreateTime];
            },
            set(value) {
                if (value == null) {
                    this.search_obj.startCreateTime = '';
                    this.search_obj.endCreateTime = '';
                } else {
                    this.search_obj.startCreateTime = value[0];
                    this.search_obj.endCreateTime = value[1];

                }
            }
        },
        dateRange2: {
            get() {
                return [this.search_obj.startDeadline, this.search_obj.endDeadline];
            },
            set(value) {
                if (value == null) {
                    this.search_obj.startDeadline = '';
                    this.search_obj.endDeadline = '';
                } else {
                    this.search_obj.startDeadline = value[0];
                    this.search_obj.endDeadline = value[1];
                }
            }
        },
    },
    watch: {
        table_data: {
            handler() {
                this.$nextTick(() => {
                    this.$refs.procTable.doLayout(); // 调用 Element UI 内置方法
                });
            },
            deep: true
        }
    },
    methods: {
        formatDateYear,
        //显示时间
        showTime() {
            this.timer = setInterval(() => {
                this.homeDate = this.$getTime()
            }, 1000);
        },
        get_data() {
            getOutSourceHeadApi(this.search_obj, this).then(res => {
                this.table_data = res.records
                this.total = res.total
            }).catch(() => { })
        },
        //页码发生变化时
        change_data(e) {
            this.search_obj.currentPage = e
            this.get_data()
        },
        //修改每页大小
        handleSizeChange(e) {
            this.search_obj.pageSize = e
            this.search_obj.currentPage = 1
            this.get_data()
        },
        gotoItem(row) {
            const { href } = this.$router.resolve({
                path: '/proc_detail',
                query: {
                    row: JSON.stringify(row),
                }
            })
            window.open(href, '_blank')
        },
        async_projectId(query) {
            get_project(this, query)
        },
        search() {
            this.search_obj.currentPage = 1
            this.get_data()
        },
        other_search() {
            this.search()
            this.other_show = false
        },
        async_procMaterial(query) {
            get_procMaterial(this, query)
        },
        async_procSupplier(query) {
            get_procSupplier(this, query)
        },

    },
    mounted() {
        this.showTime()
    },
    created() {
        this.get_data()
    },
    beforeDestroy() {
        if (this.timer) {
            clearInterval(this.timer)
            this.timer = ''
        }
    },
}
</script>
<style scoped>
.proc_nav {
    /* height: 9%; */
    display: flex;
    align-items: center;
    padding: 0 15px;
    background: #fff;
    border-bottom: 1px solid #f0f0f0;
}

.nav_left {
    width: 78%;
}

.nav_right {
    display: flex;
    gap: 12px;
    align-items: flex-end;
    justify-content: center;
    width: 22%;
}

.header-text-left {
    height: 38px;
    line-height: 38px;
    font-size: 22px;
    font-weight: 700;
    color: #fff;
}

.pe-header-text {
    margin-left: 12px;
    font-size: 16px;
    font-weight: 600;
    line-height: 45px;
    color: rgba(255, 255, 255, 0.9);
}

.header-right {
    font-size: 13px;
    height: 19px;
    line-height: 25px;
    text-align: right;
    padding-right: 15px;
    color: rgba(255, 255, 255, 0.85);
}

.header-right:first-child {
    font-weight: 500;
}

.table-body {
    /* height: 80%; */
    flex: 1;
    padding: 15px;
}

.table-footer {
    height: 5%;
    display: flex;
    padding-left: 15px;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    border-top: 1px solid #f0f0f0;
}

.page_footer {
    height: 2%!important;
    font-size: 13px;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
}




/deep/.el-table .sort-caret.ascending {
    border-bottom-color: #fff;
}

/deep/.el-table .ascending .sort-caret.ascending {
    border-bottom-color: #d5d9dd;
}

/deep/.el-table .sort-caret.descending {
    border-top-color: #fff;
}

/deep/.el-table .descending .sort-caret.descending {
    border-top-color: #d5d9dd;
}

.nav_left>>>.el-descriptions-item__cell {
    padding: 4px 5px !important;
    /* line-height: 2.5; */
}

.bg {
    height: 100%;
    display: flex;
    flex-direction: column;
}

.bg>>>.el-table .cell {
    padding: 8px 5px;
}
</style>
<style>
.el-table__body tr:hover>td {
    background-color: #c0ddaf !important;
}

.selected-row>td {
    background-color: #c0ddaf !important;
}

.table-body .el-table .el-checkbox {
    transform: scale(1.5);
}

.el-table__body-wrapper::-webkit-scrollbar {
    width: 10px;
    height: 10px;
}

.el-table__body-wrapper::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.185);
    border-radius: 5px;
}



.gen_data .el-table__body-wrapper::-webkit-scrollbar {
    width: 5px !important;
    height: 0 !important;
}
</style>